import React, { useState } from 'react';

const PieChart = ({ data }:any) => {
  const [hoveredSlice, setHoveredSlice] = useState<number | null>(null);

  if (!data || data.length === 0) {
    return <div style={{ color: '#94a3b8' }}>No hay datos disponibles</div>;
  }

  // Tomar solo los top 6 tipos
  const sortedData = [...data]
    .sort((a, b) => b.count - a.count)
    .slice(0, 6);

  const total = sortedData.reduce((sum, item) => sum + item.count, 0);

  const colors = [
    '#2563eb', // blue
    '#10b981', // green
    '#f59e0b', // orange
    '#ef4444', // red
    '#8b5cf6', // purple
    '#06b6d4'  // cyan
  ];

  let currentAngle = -90;

  const slices = sortedData.map((item, index) => {
    const percentage = (item.count / total) * 100;
    const sliceAngle = (percentage / 100) * 360;
    const startAngle = currentAngle;
    const endAngle = currentAngle + sliceAngle;

    currentAngle = endAngle;

    return {
      ...item,
      percentage: percentage.toFixed(1),
      startAngle,
      endAngle,
      color: colors[index]
    };
  });

  const polarToCartesian = (centerX:any, centerY:any, radius:any, angleInDegrees:any) => {
    const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180;
    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians)
    };
  };

  const createArc = (x:any, y:any, radius:any, startAngle:any, endAngle:any) => {
    const start = polarToCartesian(x, y, radius, endAngle);
    const end = polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

    return [
      'M', x, y,
      'L', start.x, start.y,
      'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y,
      'Z'
    ].join(' ');
  };

  const centerX = 50;
  const centerY = 50;
  const radius = 35;

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <svg
        viewBox="0 0 100 100"
        style={{ width: '100%', maxWidth: '250px', height: 'auto' }}
      >
        {slices.map((slice, index) => (
          <g key={index}>
            <path
              d={createArc(centerX, centerY, radius, slice.startAngle, slice.endAngle)}
              fill={slice.color}
              stroke="white"
              strokeWidth="0.5"
              style={{
                cursor: 'pointer',
                transition: 'all 0.3s',
                opacity: hoveredSlice === null || hoveredSlice === index ? 1 : 0.5,
                transform: hoveredSlice === index ? 'scale(1.05)' : 'scale(1)',
                transformOrigin: 'center'
              }}
              onMouseEnter={() => setHoveredSlice(index)}
              onMouseLeave={() => setHoveredSlice(null)}
            />
          </g>
        ))}

        {/* Center circle */}
        <circle
          cx={centerX}
          cy={centerY}
          r={radius * 0.5}
          fill="white"
        />
        
        {/* Center text */}
        <text
          x={centerX}
          y={centerY - 3}
          textAnchor="middle"
          fontSize="8"
          fontWeight="bold"
          fill="#1e293b"
        >
          {total}
        </text>
        <text
          x={centerX}
          y={centerY + 5}
          textAnchor="middle"
          fontSize="5"
          fill="#64748b"
        >
          Total
        </text>
      </svg>

      {/* Legend */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '8px',
        marginTop: '15px',
        width: '100%',
        maxWidth: '300px',
        fontSize: '0.8rem'
      }}>
        {slices.map((slice, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px',
              borderRadius: '6px',
              background: hoveredSlice === index ? '#f1f5f9' : 'transparent',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={() => setHoveredSlice(index)}
            onMouseLeave={() => setHoveredSlice(null)}
          >
            <div style={{
              width: '12px',
              height: '12px',
              borderRadius: '3px',
              background: slice.color,
              flexShrink: 0
            }}></div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontSize: '0.75rem',
                color: '#1e293b',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {slice.icon} {slice.name.length > 20 ? slice.name.substring(0, 20) + '...' : slice.name}
              </div>
            </div>
            <div style={{
              fontSize: '0.75rem',
              fontWeight: '600',
              color: slice.color,
              flexShrink: 0
            }}>
              {slice.percentage}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChart;